import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

// Components
import { popNotificationFromStack } from 'Console/data/notification/actions';

import Notification from './Notification';

// Actions

const styles = (theme) => ({
    notificationList: {
        position: 'fixed',
        bottom: 0,
        right: 0,
    },
});

const NotificationList = ({ classes, notifications, popNotificationFromStack }) => (
    <div className={classes.notificationList}>
        {Object.keys(notifications).map((key) => (
            <Notification
                key={key}
                popNotificationFromStack={popNotificationFromStack}
                {...notifications[key]}
            />
        ))}
    </div>
);

export default connect((state) => ({ notifications: state.notifications }), {
    popNotificationFromStack,
})(withStyles(styles)(NotificationList));
